export class TipoEncuesta {
    id: string;
    descripcion: string;
    url: string
 
    constructor(id: string, descripcion: string, url: string) {
        this.id = id;
        this.descripcion = descripcion;
        this.url = url;
     }
 
}


// WEBPACK FOOTER //
// ./src/app/models/tipo/tipo-encuesta.class.ts